var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 298.524,
    height: 294.076,
    viewBox: "0 0 298.524 294.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9677",
    "data-name": "Path 9677",
    d: "M229.154,244.918l-4.846,92.269-61.4-3.221.515-9.781,4.331-82.5,38.659,2.03Z",
    transform: "translate(-162.91 -241.69)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9689",
    "data-name": "Path 9689",
    d: "M167.294,304.006l-59.236,16.465L83.32,231.438l24.525-6.817,34.71-9.641L165,295.755Z",
    transform: "translate(-83.32 -214.98)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9715",
    "data-name": "Path 9715",
    d: "M386.663,273.266l-9,33.225a7.082,7.082,0,0,1-6.486,4.979h-51.36a3.721,3.721,0,0,1-3.795-4.964l9.009-33.225a7.089,7.089,0,0,1,6.486-4.964h51.352a3.736,3.736,0,0,1,3.993,3.464A3.787,3.787,0,0,1,386.663,273.266Z",
    transform: "translate(-315.804 -268.307)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9720",
    "data-name": "Path 9720",
    d: "M353.356,361.4v6.06H287.23V361.4a4.456,4.456,0,0,1,4.456-4.456h57.206a4.449,4.449,0,0,1,4.464,4.456Z",
    transform: "translate(-287.23 -356.94)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M277.91,356c-3.17,3.228,12.193,53.956,12.193,53.956a12.38,12.38,0,0,1-6.486,2.456,29.824,29.824,0,0,1-6.479.1s-22.018-53.4-15.958-66.656,43.66-19.267,43.66-19.267l1.6-3.971,19.451-2.736,3.214,23.819s-3.192.309-7.994.927C308.238,346.258,283.735,350.119,277.91,356Z",
    transform: "translate(-260.125 -319.88)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9728",
    "data-name": "Path 9728",
    d: "M269.4,296.261c-3.228-.552,19.753-20.7,19.753-20.7l11.082,7.457s-18.855,13.281-21.819,13.642A52.148,52.148,0,0,1,269.4,296.261Z",
    transform: "translate(-269.087 -275.56)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9740",
    "data-name": "Path 9740",
    d: "M288.93,435.09l6.126,16.112s1.015,4.14-17.458,2.831l-10.178-.868Z",
    transform: "translate(-267.42 -435.09)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M323.145,270.481a13.524,13.524,0,0,1-.735-5.464,16.06,16.06,0,0,1,.2-1.875l-1.243-1.971-1.6-2.537,1.846-7.354s11.766,2.265,12.649,5.545S323.145,270.481,323.145,270.481Z",
    transform: "translate(-319.77 -251.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9792",
    "data-name": "Path 9792",
    d: "M372.861,397a50.235,50.235,0,0,0-15.583,16.179c-6.479,10.81-11.612,26.018-3.64,27.945l7.582-.287,14.59-5.008-1.53-2.942s-12.774,6.766-14.958,6.766-5.03.544-6.229-.331,4.2-20.532,15.752-27.084S372.861,397,372.861,397Z",
    transform: "translate(-349.575 -397)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9797",
    "data-name": "Path 9797",
    d: "M379.985,438.8c-10.156,0-8.229-45.543-7.06-47.8s30.636-3.383,33.541-2.427,14.553,46.33,8.126,49.955Z",
    transform: "translate(-371.966 -388.235)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9802",
    "data-name": "Path 9802",
    d: "M408.16,403.542l4.324,3.53a.588.588,0,0,1,.066.831h0l-3.368,3.633a.574.574,0,0,1-.809,0h0l-4.3-4.008a.581.581,0,0,1,0-.809h0l3.331-3.1A.574.574,0,0,1,408.16,403.542Z",
    transform: "translate(-403.907 -403.435)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9806",
    "data-name": "Path 9806",
    d: "M390.22,428.475s19.547,1.611,29.144-.875a8.244,8.244,0,0,1,2.743,3.934c.875,2.618,2.7,11.575-2.743,13.869s-25,1.853-27.614-.735S390.22,428.475,390.22,428.475Z",
    transform: "translate(-389.998 -427.6)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9811",
    "data-name": "Path 9811",
    d: "M376.664,427s.655,12.994,1.964,15.943a6.8,6.8,0,0,1-6.295,0c-3.309-1.75-2.765-12.943-2.111-12.913S376.664,427,376.664,427Z",
    transform: "translate(-369.729 -427)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exams-bro",
    transform: "translate(-47.21 -55.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clocks--inject-143",
    transform: "translate(47.71 56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4119",
    "data-name": "Group 4119",
    transform: "translate(132.551 4.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9631",
    "data-name": "Path 9631",
    d: "M229.79,44.183c.993,3.934.507-3.309,2.456-12.178s5.28-5.265,5.28-5.265",
    transform: "translate(-229.18 -26.015)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y1: 2.5,
    x2: 6.111,
    transform: "translate(0 6.607)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9632",
    "data-name": "Path 9632",
    d: "M243.708,30.92s-3.677,7.545,1.846,10.759",
    transform: "translate(-232.545 -27.314)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9633",
    "data-name": "Path 9633",
    d: "M251.18,28s6.023,3.346,2.25,10.6",
    transform: "translate(-234.839 -26.542)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 4.317,
    y2: 3.155,
    transform: "translate(12.207 6.159)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x1: 3.383,
    y2: 5.376,
    transform: "translate(12.214 4.775)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9634",
    "data-name": "Path 9634",
    d: "M67.605,292.42s-10.244-.147-10.3,8.692",
    transform: "translate(-50.25 -125.126)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9635",
    "data-name": "Path 9635",
    d: "M68.165,299.438c-.213-1.3-4.67-2.942-5.442.456s4.765,1.36,6.479-.228c0,0-3.177,3.089-2.206,3.956",
    transform: "translate(-51.663 -126.57)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9636",
    "data-name": "Path 9636",
    d: "M69.992,307s-1.346,1.684-2.8.882",
    transform: "translate(-52.865 -128.984)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9637",
    "data-name": "Path 9637",
    d: "M80.425,299l-7.685,7.8s3.868-3.92,6.111-2.655c2.794,1.53-.831,5.721-3.817,2.721",
    transform: "translate(-54.333 -126.867)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9638",
    "data-name": "Path 9638",
    d: "M85.419,301.86s2.037,9.332-8.479,9.663",
    transform: "translate(-55.445 -127.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9639",
    "data-name": "Path 9639",
    d: "M275.03,84.053l3.706.61.051,8.42,8.119-14.8,12.811,2.1",
    transform: "translate(-107.861 -68.463)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x2: 5.633,
    y2: 9.942,
    transform: "translate(180.45 16.304)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x1: 10.082,
    y2: 7.361,
    transform: "translate(177.45 17.466)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9640",
    "data-name": "Path 9640",
    d: "M204.2,106.328c-.949-1.206-6.413-.346-5.3,3.523s5.626-1.287,6.486-3.868c0,0-1.508,4.934,0,5.265",
    transform: "translate(-87.676 -75.75)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9641",
    "data-name": "Path 9641",
    d: "M211.411,101.1l-1.221,4.339s.61-2.206,1.684-2.206c1.316,0,.838,2.206-.846,1.75",
    transform: "translate(-90.704 -74.501)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9642",
    "data-name": "Path 9642",
    d: "M351,173.82l-2.574,9.3,5.626,6.163",
    transform: "translate(-127.283 -93.743)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x2: 6.442,
    y2: 5.39,
    transform: "translate(226.942 83.857)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x1: 2.787,
    y2: 6.846,
    transform: "translate(228.589 82.533)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9643",
    "data-name": "Path 9643",
    d: "M368.22,185.27s.059,1.941-.78,2.206",
    transform: "translate(-132.314 -96.773)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    x2: 3.89,
    y2: 2.89,
    transform: "translate(236.722 81.717)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x1: 3.839,
    y2: 13.825,
    transform: "translate(238.215 79.341)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9644",
    "data-name": "Path 9644",
    d: "M377.12,166.29l6.236,7.06-2.655,7.722",
    transform: "translate(-134.875 -91.751)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9645",
    "data-name": "Path 9645",
    d: "M143.58,404.346,152.6,377.49,163.546,389.7Z",
    transform: "translate(-73.078 -147.636)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9646",
    "data-name": "Path 9646",
    d: "M166.249,395.053l-2.309-2.64,2.464-2.133",
    transform: "translate(-78.466 -151.021)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 9.185,
    cy: 9.185,
    r: 9.185,
    transform: "translate(1.651 92.364) rotate(-22.5)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 10.193,
    cy: 10.193,
    r: 10.193,
    transform: "translate(13.649 79.099)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x1: 1.243,
    y2: 4.317,
    transform: "translate(14.215 88.328)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x1: 1.758,
    y2: 6.221,
    transform: "translate(15.458 88.865)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 1.846,
    y2: 7.038,
    transform: "translate(17.215 89.909)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x1: 1.316,
    y2: 6.677,
    transform: "translate(19.797 91.975)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x1: 1.155,
    y2: 4.964,
    transform: "translate(21.113 94.152)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9647",
    "data-name": "Path 9647",
    d: "M53.637,181.092c-.8-.243-3,1.846-1.294,3.25s2.14-2.339,1.721-3.773c0,0,.86,2.7,1.64,2.375",
    transform: "translate(-48.768 -95.529)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9648",
    "data-name": "Path 9648",
    d: "M70.45,165.25l2.942,5.354s-1.471-2.677-.434-3.677c1.265-1.235,2.942,1.375.824,2.471",
    transform: "translate(-53.727 -91.476)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    x2: 4.155,
    y2: 3.934,
    transform: "translate(70.472 73.135)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x1: 3.478,
    y2: 5.192,
    transform: "translate(71.149 72.112)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y1: 1.552,
    x2: 4.155,
    transform: "translate(78.716 72.054)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 2.53,
    y2: 2.236,
    transform: "translate(84.864 67.722)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x1: 3.199,
    y2: 10.987,
    transform: "translate(86.129 65.031)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9649",
    "data-name": "Path 9649",
    d: "M416.076,147.338l-.176-8.4h6.346s-3.515,1.941-1.9,6.457,4.221,1.941,4.221,1.941",
    transform: "translate(-145.137 -84.514)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9650",
    "data-name": "Path 9650",
    d: "M401.52,343.381l7.221-4.971,9.56.669.6,12.119-7.016,5.023-8.663-.632Z",
    transform: "translate(-141.331 -137.295)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9651",
    "data-name": "Path 9651",
    d: "M403.83,359.96l6.986-5.03,8.692.64",
    transform: "translate(-141.943 -141.667)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x1: 1.471,
    y1: 12.149,
    transform: "translate(267.41 201.115)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9652",
    "data-name": "Path 9652",
    d: "M401.52,343.622l9.538,1.1,7.244-5.405",
    transform: "translate(-141.331 -137.536)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x2: 0.824,
    y2: 11.737,
    transform: "translate(269.727 207.189)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9653",
    "data-name": "Path 9653",
    d: "M403.2,221.39l-.309,16.157,14.156-6.427Z",
    transform: "translate(-141.694 -106.331)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x2: 6.744,
    y2: 12.862,
    transform: "translate(261.505 115.059)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9654",
    "data-name": "Path 9654",
    d: "M411.01,235.784l1.64-.794,1.1,2.2",
    transform: "translate(-143.843 -109.929)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x2: 5.854,
    y2: 6.273,
    transform: "translate(138.077 113.53)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x1: 4.92,
    y2: 6.736,
    transform: "translate(139.055 112.684)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9655",
    "data-name": "Path 9655",
    d: "M246.612,213.651a1.169,1.169,0,0,1,1.552.566,1.207,1.207,0,0,1,.1.316c.287,1.412-2.03,3.25-2.03,3.25h3.3",
    transform: "translate(-100.24 -104.254)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9656",
    "data-name": "Path 9656",
    d: "M111.54,85.345A21.268,21.268,0,0,1,122.747,68.24",
    transform: "translate(-64.6 -65.806)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9657",
    "data-name": "Path 9657",
    d: "M128.98,118.669A21.267,21.267,0,0,1,116,109.41",
    transform: "translate(-65.78 -76.7)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9658",
    "data-name": "Path 9658",
    d: "M161.047,96.11a21.326,21.326,0,0,1-22.937,19.547",
    transform: "translate(-71.631 -73.181)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M142.72,64.93a21.326,21.326,0,0,1,19.422,18.341",
    transform: "translate(-72.851 -64.93)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9660",
    "data-name": "Path 9660",
    d: "M142.843,109.669A18.8,18.8,0,0,1,114.9,91.77",
    transform: "translate(-65.473 -72.032)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9661",
    "data-name": "Path 9661",
    d: "M116.56,80.273a18.8,18.8,0,1,1,31.57,19.282",
    transform: "translate(-65.928 -65.801)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9662",
    "data-name": "Path 9662",
    d: "M137.91,75.41l1.846,13.531,10.4-3.236",
    transform: "translate(-71.578 -67.703)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9663",
    "data-name": "Path 9663",
    d: "M355.54,120.335A14.752,14.752,0,0,1,345.473,94.67",
    transform: "translate(-125.223 -72.799)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9664",
    "data-name": "Path 9664",
    d: "M376.43,116a14.708,14.708,0,0,1-9.06,9.156",
    transform: "translate(-132.295 -78.444)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9665",
    "data-name": "Path 9665",
    d: "M354.05,90.288A14.752,14.752,0,0,1,372.861,99.3",
    transform: "translate(-128.77 -71.417)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9666",
    "data-name": "Path 9666",
    d: "M364.524,94.84a13.016,13.016,0,1,1-16.914,19.547",
    transform: "translate(-127.066 -72.844)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9667",
    "data-name": "Path 9667",
    d: "M343.735,109.143a13.016,13.016,0,0,1,15.553-16.914",
    transform: "translate(-125.846 -72.043)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9668",
    "data-name": "Path 9668",
    d: "M353.95,98.58l4.971,8.038-4.53,5.876",
    transform: "translate(-128.744 -73.834)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9669",
    "data-name": "Path 9669",
    d: "M219,404.905a11.81,11.81,0,0,1,5.148-9.8",
    transform: "translate(-93.035 -152.299)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9670",
    "data-name": "Path 9670",
    d: "M239.595,417.949a11.832,11.832,0,0,1-19.775-4.339",
    transform: "translate(-93.252 -157.194)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9671",
    "data-name": "Path 9671",
    d: "M235.05,392.34a11.832,11.832,0,0,1,11.832,11.832",
    transform: "translate(-97.282 -151.566)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9672",
    "data-name": "Path 9672",
    d: "M231.3,418.865A10.435,10.435,0,0,1,220.86,408.43h0",
    transform: "translate(-93.527 -155.823)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9673",
    "data-name": "Path 9673",
    d: "M224,398.126A10.443,10.443,0,1,1,237.237,413.8",
    transform: "translate(-94.358 -152.072)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9674",
    "data-name": "Path 9674",
    d: "M232.62,413.434l1.618-7.089-2.258-5.795",
    transform: "translate(-96.47 -153.738)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x2: 297.524,
    transform: "translate(0 288.288)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exam-sheets--inject-143",
    transform: "translate(73.897 145.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9675",
    "data-name": "Path 9675",
    d: "M229.154,244.918l-4.846,92.269-61.4-3.221.515-9.781,4.331-82.5,38.659,2.03Z",
    transform: "translate(-104.38 -201.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105",
    transform: "translate(58.53 40.209)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9676",
    "data-name": "Path 9676",
    d: "M210.175,298.977l-13.833,1.14,4.037,17.421-36.77,6.648,4.331-82.5,38.659,2.03Z",
    transform: "translate(-163.095 -241.69)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9678",
    "data-name": "Path 9678",
    d: "M229.154,244.918l-4.846,92.269-61.4-3.221.515-9.781,4.331-82.5,38.659,2.03Z",
    transform: "translate(-104.38 -201.481)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x2: 15.98,
    y2: 0.838,
    transform: "translate(67.707 46.519)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    x2: 10.869,
    y2: 0.574,
    transform: "translate(67.546 49.585)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    x2: 45.962,
    y2: 2.412,
    transform: "translate(71.061 57.035)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    x2: 45.962,
    y2: 2.412,
    transform: "translate(70.899 60.101)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x2: 39.196,
    y2: 2.052,
    transform: "translate(70.715 63.683)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 3.743,
    height: 3.743,
    transform: "translate(70.534 70.688) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 3.743,
    height: 3.743,
    transform: "translate(77.31 71.046) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 3.743,
    height: 3.743,
    transform: "translate(84.077 71.406) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 3.743,
    height: 3.743,
    transform: "translate(90.852 71.764) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9679",
    "data-name": "Path 9679",
    d: "M175.954,264.038a.927.927,0,0,1-.963.89h0a.939.939,0,1,1,.978-.9Z",
    transform: "translate(-107.342 -207.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    x2: 45.962,
    y2: 2.412,
    transform: "translate(70.12 74.927)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x2: 45.962,
    y2: 2.412,
    transform: "translate(69.958 77.994)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x2: 39.196,
    y2: 2.052,
    transform: "translate(69.774 81.575)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 3.743,
    height: 3.743,
    transform: "translate(69.585 88.591) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 3.743,
    height: 3.743,
    transform: "translate(76.368 88.943) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 3.743,
    height: 3.743,
    transform: "translate(83.135 89.295) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1427",
    "data-name": "Rectangle 1427",
    width: 3.743,
    height: 3.743,
    transform: "translate(89.903 89.653) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9680",
    "data-name": "Path 9680",
    d: "M174.676,288.363a.934.934,0,0,1-.978.89h0a.941.941,0,1,1,.985-.9Z",
    transform: "translate(-106.998 -213.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x2: 45.955,
    y2: 2.412,
    transform: "translate(69.186 92.819)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x2: 45.955,
    y2: 2.412,
    transform: "translate(69.024 95.886)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 39.196,
    y2: 2.059,
    transform: "translate(68.833 99.46)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1428",
    "data-name": "Rectangle 1428",
    width: 3.743,
    height: 3.743,
    transform: "translate(68.651 106.473) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 3.75,
    height: 3.75,
    transform: "matrix(0.05, -0.999, 0.999, 0.05, 76.229, 106.818)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.001
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 3.743,
    height: 3.743,
    transform: "translate(82.194 107.191) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1431",
    "data-name": "Rectangle 1431",
    width: 3.743,
    height: 3.743,
    transform: "translate(88.976 107.542) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9681",
    "data-name": "Path 9681",
    d: "M173.379,312.693a.934.934,0,0,1-.978.89h0a.941.941,0,1,1,0-1.883h.132a.934.934,0,0,1,.89.978Z",
    transform: "translate(-106.643 -220.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x2: 45.955,
    y2: 2.419,
    transform: "translate(68.215 111.218)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x2: 45.962,
    y2: 2.419,
    transform: "translate(68.053 114.285)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x2: 39.196,
    y2: 2.059,
    transform: "translate(67.869 117.866)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    "data-name": "Rectangle 1432",
    width: 3.743,
    height: 3.743,
    transform: "translate(67.677 124.881) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    width: 3.743,
    height: 3.743,
    transform: "translate(74.46 125.233) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    width: 3.743,
    height: 3.743,
    transform: "translate(81.243 125.585) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 3.743,
    height: 3.743,
    transform: "translate(88.011 125.951) rotate(-86.99)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9682",
    "data-name": "Path 9682",
    d: "M172.078,337.725a.934.934,0,1,1-.237-.676.934.934,0,0,1,.237.676Z",
    transform: "translate(-106.312 -226.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9683",
    "data-name": "Path 9683",
    d: "M181.23,279.681l.485.838,1.993-2.2",
    transform: "translate(-109.228 -211.173)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9684",
    "data-name": "Path 9684",
    d: "M198.39,304.67l.485.838,1.993-2.2",
    transform: "translate(-113.769 -217.786)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9685",
    "data-name": "Path 9685",
    d: "M207,330.348l.485.838,1.993-2.206",
    transform: "translate(-116.047 -224.579)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9686",
    "data-name": "Path 9686",
    d: "M186.6,353.268l.485.831,1.993-2.2",
    transform: "translate(-110.649 -230.643)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9687",
    "data-name": "Path 9687",
    d: "M167.294,304.006l-59.236,16.465L83.32,231.438l24.525-6.817,34.71-9.641L165,295.755Z",
    transform: "translate(-83.32 -194.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4106",
    "data-name": "Group 4106",
    transform: "translate(0 20.567)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9688",
    "data-name": "Path 9688",
    d: "M173.825,295.755l-45.8,2.964-11.354-74.1,34.71-9.641Z",
    transform: "translate(-92.145 -214.98)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9690",
    "data-name": "Path 9690",
    d: "M167.294,304.006l-59.236,16.465L83.32,231.438l24.525-6.817,34.71-9.641L165,295.755Z",
    transform: "translate(-83.32 -194.413)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    y1: 4.28,
    x2: 15.414,
    transform: "translate(6.118 37.348)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    y1: 2.912,
    x2: 10.487,
    transform: "translate(6.935 41.68)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    y1: 12.318,
    x2: 44.344,
    transform: "translate(12.634 38.216)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    y1: 12.318,
    x2: 44.344,
    transform: "translate(13.458 41.173)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    y1: 10.509,
    x2: 37.821,
    transform: "translate(14.414 46.438)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 15.48, 60.041)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 22.019, 58.217)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 28.559, 56.399)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    "data-name": "Rectangle 1439",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 35.088, 54.586)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9691",
    "data-name": "Path 9691",
    d: "M96.629,256.373a.935.935,0,1,1-1.151-.651A.935.935,0,0,1,96.629,256.373Z",
    transform: "translate(-86.356 -205.185)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    y1: 12.318,
    x2: 44.344,
    transform: "translate(17.429 55.476)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    y1: 12.325,
    x2: 44.344,
    transform: "translate(18.252 58.432)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    y1: 10.509,
    x2: 37.814,
    transform: "translate(19.216 63.698)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 20.279, 77.297)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 26.812, 75.482)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 33.353, 73.666)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 39.899, 71.84)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9692",
    "data-name": "Path 9692",
    d: "M103.155,279.852a.941.941,0,1,1-1.162-.655h0a.934.934,0,0,1,1.155.647Z",
    transform: "translate(-88.079 -211.396)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    y1: 12.325,
    x2: 44.337,
    transform: "translate(22.231 72.736)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    y1: 12.318,
    x2: 44.337,
    transform: "translate(23.054 75.699)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    y1: 10.509,
    x2: 37.821,
    transform: "translate(24.011 80.965)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 25.071, 94.556)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 31.618, 92.738)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 38.145, 90.924)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 44.685, 89.107)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9693",
    "data-name": "Path 9693",
    d: "M109.675,303.322a.941.941,0,1,1-1.162-.654h0a.934.934,0,0,1,1.155.647Z",
    transform: "translate(-89.805 -217.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    y1: 12.318,
    x2: 44.337,
    transform: "translate(27.165 90.495)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    y1: 12.325,
    x2: 44.344,
    transform: "translate(27.982 93.451)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    y1: 10.509,
    x2: 37.821,
    transform: "translate(28.945 98.717)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 30.006, 112.317)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 36.546, 110.499)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 43.087, 108.683)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    width: 3.743,
    height: 3.743,
    transform: "matrix(0.963, -0.268, 0.268, 0.963, 49.62, 106.868)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9694",
    "data-name": "Path 9694",
    d: "M116.386,327.465a.941.941,0,1,1-1.162-.647h0a.941.941,0,0,1,1.155.64Z",
    transform: "translate(-91.581 -223.997)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9695",
    "data-name": "Path 9695",
    d: "M115.04,267.031l.728.64,1.191-2.721",
    transform: "translate(-91.713 -207.636)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9696",
    "data-name": "Path 9696",
    d: "M112.63,293.221l.728.64,1.184-2.721",
    transform: "translate(-91.076 -214.566)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9697",
    "data-name": "Path 9697",
    d: "M119.15,316.451l.728.64,1.184-2.721",
    transform: "translate(-92.801 -220.713)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9698",
    "data-name": "Path 9698",
    d: "M143.62,335.481l.728.64,1.191-2.721",
    transform: "translate(-99.276 -225.748)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 61.479,
    height: 92.402,
    transform: "translate(28.562 5.882) rotate(-5.49)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    y1: 1.53,
    x2: 15.929,
    transform: "translate(33.776 9.963)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    y1: 1.044,
    x2: 10.832,
    transform: "translate(34.071 13.507)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    y1: 4.405,
    x2: 45.807,
    transform: "translate(38.645 16.993)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    y1: 4.398,
    x2: 45.807,
    transform: "translate(38.939 20.052)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    y1: 3.75,
    x2: 39.071,
    transform: "translate(39.285 24.266)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 3.743,
    height: 3.743,
    transform: "translate(39.799 31.242) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 3.743,
    height: 3.743,
    transform: "translate(46.553 30.592) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 3.743,
    height: 3.743,
    transform: "translate(53.306 29.949) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 3.743,
    height: 3.743,
    transform: "translate(60.059 29.291) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9699",
    "data-name": "Path 9699",
    d: "M131.884,216.124a.941.941,0,1,1-1.03-.846h0a.934.934,0,0,1,1.022.838Z",
    transform: "translate(-95.674 -194.491)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    y1: 4.398,
    x2: 45.807,
    transform: "translate(40.358 34.833)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    y1: 4.405,
    x2: 45.807,
    transform: "translate(40.652 37.885)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    y1: 3.758,
    x2: 39.071,
    transform: "translate(40.998 42.099)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 3.743,
    height: 3.743,
    transform: "translate(41.512 49.073) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 3.743,
    height: 3.743,
    transform: "translate(48.265 48.429) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 3.743,
    height: 3.743,
    transform: "translate(55.019 47.779) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 3.743,
    height: 3.743,
    transform: "translate(61.773 47.143) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9700",
    "data-name": "Path 9700",
    d: "M134.214,240.374a.941.941,0,1,1-1.03-.846h0a.941.941,0,0,1,1.03.846Z",
    transform: "translate(-96.29 -200.908)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    y1: 4.398,
    x2: 45.807,
    transform: "translate(42.072 52.667)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    y1: 4.405,
    x2: 45.807,
    transform: "translate(42.366 55.719)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y1: 3.758,
    x2: 39.071,
    transform: "translate(42.711 59.932)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 3.743,
    height: 3.743,
    transform: "translate(43.225 66.91) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 3.743,
    height: 3.743,
    transform: "translate(49.978 66.26) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 3.743,
    height: 3.743,
    transform: "translate(56.732 65.616) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 3.743,
    height: 3.743,
    transform: "translate(63.486 64.966) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9701",
    "data-name": "Path 9701",
    d: "M136.539,264.624a.934.934,0,1,1-1.015-.846A.934.934,0,0,1,136.539,264.624Z",
    transform: "translate(-96.909 -207.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 4.405,
    x2: 45.807,
    transform: "translate(43.837 71.007)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    y1: 4.398,
    x2: 45.807,
    transform: "translate(44.131 74.067)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    y1: 3.75,
    x2: 39.071,
    transform: "translate(44.469 78.28)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 3.743,
    height: 3.743,
    transform: "translate(44.987 85.255) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 3.743,
    height: 3.743,
    transform: "translate(51.748 84.611) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1467",
    "data-name": "Rectangle 1467",
    width: 3.743,
    height: 3.743,
    transform: "translate(58.493 83.955) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1468",
    "data-name": "Rectangle 1468",
    width: 3.743,
    height: 3.743,
    transform: "translate(65.247 83.304) rotate(-5.49)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9702",
    "data-name": "Path 9702",
    d: "M138.934,289.567a.934.934,0,1,1-.337-.631A.941.941,0,0,1,138.934,289.567Z",
    transform: "translate(-97.539 -213.926)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9703",
    "data-name": "Path 9703",
    d: "M139.44,230.733l.6.757,1.647-2.471",
    transform: "translate(-98.17 -198.128)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M160.11,252.913l.6.757,1.64-2.471",
    transform: "translate(-103.639 -203.997)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9705",
    "data-name": "Path 9705",
    d: "M153.3,278.553l.6.757,1.647-2.471",
    transform: "translate(-101.837 -210.782)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9706",
    "data-name": "Path 9706",
    d: "M173.93,301.543l.6.757,1.647-2.471",
    transform: "translate(-107.296 -216.865)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-143",
    transform: "translate(195.443 109.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9707",
    "data-name": "Path 9707",
    d: "M291.657,137.71h-38a5.06,5.06,0,0,0-5.059,5.059h0v32.659a5.059,5.059,0,0,0,5.059,5.059H270.5l9.648,11.627-2.419-11.627h13.928a5.059,5.059,0,0,0,5.037-5.059V142.769a5.059,5.059,0,0,0-5.037-5.059Z",
    transform: "translate(-248.6 -137.71)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9708",
    "data-name": "Path 9708",
    d: "M278.61,158.035v-3.456l-2.589-.221a7.5,7.5,0,0,0-.64-1.552l1.669-1.986-2.449-2.441-1.986,1.669a6.972,6.972,0,0,0-1.552-.64l-.221-2.589h-3.456l-.221,2.589a6.972,6.972,0,0,0-1.552.64l-1.986-1.669-2.449,2.441,1.655,2.015a7.353,7.353,0,0,0-.647,1.552l-2.589.221v3.456l2.589.228a7.353,7.353,0,0,0,.647,1.552l-1.677,1.986,2.449,2.442,1.986-1.669a6.971,6.971,0,0,0,1.552.64l.221,2.589h3.456l.221-2.589a6.971,6.971,0,0,0,1.552-.64l1.986,1.669,2.449-2.442-1.669-1.986a7.5,7.5,0,0,0,.64-1.552Zm-9.494,2.294a4.023,4.023,0,1,1,4.015-4.03h0a4.008,4.008,0,0,1-4.008,4.023Z",
    transform: "translate(-251.511 -140.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    "data-name": "Path 9709",
    d: "M296.139,169.689v-2.456l-1.846-.162a4.989,4.989,0,0,0-.456-1.1l1.191-1.412-1.736-1.736L291.874,164a5.362,5.362,0,0,0-1.1-.456l-.154-1.838h-2.464L288,163.548a5.427,5.427,0,0,0-1.11.456l-1.412-1.184-1.736,1.736,1.184,1.412a4.965,4.965,0,0,0-.449,1.1l-1.846.162v2.456l1.846.162a4.964,4.964,0,0,0,.449,1.1l-1.184,1.412,1.736,1.743,1.412-1.191a4.706,4.706,0,0,0,1.11.456l.154,1.846h2.464l.154-1.846a4.657,4.657,0,0,0,1.1-.456l1.419,1.191,1.736-1.743-1.191-1.412a4.655,4.655,0,0,0,.456-1.1Zm-6.758,1.633a2.861,2.861,0,1,1,2.861-2.861A2.861,2.861,0,0,1,289.381,171.322Z",
    transform: "translate(-257.605 -144.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    "data-name": "Path 9710",
    d: "M281.182,178.313v-1.728l-1.316-.118a3.48,3.48,0,0,0-.324-.787l.846-1-1.235-1.243-1.007.846a4.25,4.25,0,0,0-.78-.324l-.118-1.309H275.5l-.11,1.309a3.852,3.852,0,0,0-.787.324l-1.008-.846-1.235,1.243.846,1a3.853,3.853,0,0,0-.324.787l-1.309.118v1.743l1.309.118a3.852,3.852,0,0,0,.324.787l-.846,1.03,1.235,1.243,1.008-.846a4.317,4.317,0,0,0,.787.324l.11,1.309h1.75l.118-1.309a4.25,4.25,0,0,0,.78-.324l1.007.846,1.235-1.243-.846-1a3.478,3.478,0,0,0,.324-.787Zm-4.809,1.162a2.037,2.037,0,1,1,2.037-2.037h0a2.037,2.037,0,0,1-2.037,2.03Z",
    transform: "translate(-254.678 -146.955)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-143",
    transform: "translate(181.147 164.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9711",
    "data-name": "Path 9711",
    d: "M279.93,308.37l29.622,109.264h4.427L284.364,308.37Z",
    transform: "translate(-242.594 -237.735)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1469",
    "data-name": "Rectangle 1469",
    width: 56.147,
    height: 4.574,
    transform: "translate(47.903 148.925)",
    fill: "#999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9712",
    "data-name": "Path 9712",
    d: "M377.232,270.237,340.955,404.078h-4.412l36.27-133.841c1.338-4.934-1.728-8.95-6.839-8.95H334.719a12.808,12.808,0,0,0-11.693,8.95L286.742,404.078H282.33l36.277-133.841c1.978-7.3,9.715-13.237,17.274-13.237h31.261C374.68,257,379.21,262.927,377.232,270.237Z",
    transform: "translate(-243.229 -224.142)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9713",
    "data-name": "Path 9713",
    d: "M386.663,273.266l-9,33.225a7.082,7.082,0,0,1-6.486,4.979h-51.36a3.721,3.721,0,0,1-3.795-4.964l9.009-33.225a7.089,7.089,0,0,1,6.486-4.964h51.352a3.736,3.736,0,0,1,3.993,3.464A3.787,3.787,0,0,1,386.663,273.266Z",
    transform: "translate(-252.087 -227.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    transform: "translate(63.717 41.173)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9714",
    "data-name": "Path 9714",
    d: "M386.663,273.263l-9,33.225a7.082,7.082,0,0,1-6.486,4.979h-51.36a3.721,3.721,0,0,1-3.795-4.964l9.009-33.225a7.089,7.089,0,0,1,6.486-4.964h26.555c11.479,11.766,10.016,33.453,9.266,40a7.163,7.163,0,0,0,5.148-4.795l8.986-33.232a4.493,4.493,0,0,0,.11-1.978h1.287a3.736,3.736,0,0,1,3.795,4.957Z",
    transform: "translate(-315.804 -268.304)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M386.663,273.266l-9,33.225a7.082,7.082,0,0,1-6.486,4.979h-51.36a3.721,3.721,0,0,1-3.795-4.964l9.009-33.225a7.089,7.089,0,0,1,6.486-4.964h51.352a3.736,3.736,0,0,1,3.993,3.464A3.787,3.787,0,0,1,386.663,273.266Z",
    transform: "translate(-252.087 -227.134)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9717",
    "data-name": "Path 9717",
    d: "M371.1,372.71l16.8,61.949h4.427L375.534,372.71Z",
    transform: "translate(-266.719 -254.76)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9718",
    "data-name": "Path 9718",
    d: "M353.356,361.4v6.06H287.23V361.4a4.456,4.456,0,0,1,4.456-4.456h57.206a4.449,4.449,0,0,1,4.464,4.456Z",
    transform: "translate(-244.526 -250.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108",
    transform: "translate(42.704 106.353)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9719",
    "data-name": "Path 9719",
    d: "M353.2,360.257c-2.14,2.515-5.979,5.074-12.583,7.229H287.23V361.4a4.456,4.456,0,0,1,4.456-4.456h57.206A4.464,4.464,0,0,1,353.2,360.257Z",
    transform: "translate(-287.23 -356.94)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M353.356,361.4v6.06H287.23V361.4a4.456,4.456,0,0,1,4.456-4.456h57.206a4.449,4.449,0,0,1,4.464,4.456Z",
    transform: "translate(-244.526 -250.587)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 72.554,
    height: 5.685,
    rx: 1.71,
    transform: "translate(39.777 115.038)",
    fill: "#999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9722",
    "data-name": "Path 9722",
    d: "M277.91,356c-3.17,3.228,12.193,53.956,12.193,53.956a12.38,12.38,0,0,1-6.486,2.456,29.824,29.824,0,0,1-6.479.1s-22.018-53.4-15.958-66.656,43.66-19.267,43.66-19.267l1.6-3.971,19.451-2.736,3.214,23.819s-3.192.309-7.994.927C308.238,346.258,283.735,350.119,277.91,356Z",
    transform: "translate(-237.354 -240.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109",
    transform: "translate(22.771 79.099)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    d: "M294.258,413.832a12.38,12.38,0,0,1-6.486,2.456c-4.273-15.884-15.149-58.272-11.031-63.457,5.082-6.4,30.232-12.215,30.232-12.215.1-3.265,8.92-6.207,8.92-6.207l9.369,14.039c-12.877,1.655-37.38,5.515-43.2,11.4C278.9,363.1,294.258,413.832,294.258,413.832Z",
    transform: "translate(-264.28 -323.725)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M277.91,356c-3.17,3.228,12.193,53.956,12.193,53.956a12.38,12.38,0,0,1-6.486,2.456,29.824,29.824,0,0,1-6.479.1s-22.018-53.4-15.958-66.656,43.66-19.267,43.66-19.267l1.6-3.971,19.451-2.736,3.214,23.819s-3.192.309-7.994.927C308.238,346.258,283.735,350.119,277.91,356Z",
    transform: "translate(-237.354 -240.781)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    d: "M269.4,296.261c-3.228-.552,19.753-20.7,19.753-20.7l11.082,7.457s-18.855,13.281-21.819,13.642A52.148,52.148,0,0,1,269.4,296.261Z",
    transform: "translate(-239.725 -229.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110",
    transform: "translate(29.362 46.507)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    d: "M269.4,296.261c-3.228-.552,19.753-20.7,19.753-20.7l11.082,7.457s-18.855,13.281-21.819,13.642A52.148,52.148,0,0,1,269.4,296.261Z",
    transform: "translate(-269.087 -275.56)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9729",
    "data-name": "Path 9729",
    d: "M269.4,296.261c-3.228-.552,19.753-20.7,19.753-20.7l11.082,7.457s-18.855,13.281-21.819,13.642A52.148,52.148,0,0,1,269.4,296.261Z",
    transform: "translate(-239.725 -229.053)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9730",
    "data-name": "Path 9730",
    d: "M275,292.19s4.817,1.2,6.295,2.206,1.052,4.648,1.052,4.648S275.927,297.235,275,292.19Z",
    transform: "translate(-241.29 -233.454)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9731",
    "data-name": "Path 9731",
    d: "M270.82,279.336l8.957,17.179h1.059l-8.508-18.024Z",
    transform: "translate(-240.184 -229.829)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M277.283,295.085s-5.648-4.015-7.03-4.015-5.523,4.89-5.523,7.354,9.031,3.809,10.8,1.728c.882-1.037-.868-3.537-.868-3.537a33.091,33.091,0,0,0,3.375,3.125c.735.412,2.14-.125,2.14-.125S278.291,296.6,277.283,295.085Z",
    transform: "translate(-238.572 -233.157)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M276.534,302.708a16.959,16.959,0,0,0-4.714-4.118",
    transform: "translate(-240.448 -235.147)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M277.052,297.841a12.113,12.113,0,0,0-3.272-2.081",
    transform: "translate(-240.967 -234.398)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M269.86,301.54a34.633,34.633,0,0,1,3.949,2.368",
    transform: "translate(-239.93 -235.928)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M300.45,263.58c-2.89,2.015-15.87,15.362-15.87,15.362s6.082,6.92,11.413,7.92l14.45-7.016Z",
    transform: "translate(-243.825 -225.883)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9737",
    "data-name": "Path 9737",
    d: "M300.45,263.58c-2.89,2.015-15.87,15.362-15.87,15.362s6.082,6.92,11.413,7.92l14.45-7.016Z",
    transform: "translate(-243.825 -225.883)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9738",
    "data-name": "Path 9738",
    d: "M288.93,435.09l6.126,16.112s1.015,4.14-17.458,2.831l-10.178-.868Z",
    transform: "translate(-239.284 -271.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111",
    transform: "translate(28.136 163.824)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9739",
    "data-name": "Path 9739",
    d: "M288.93,435.09l6.126,16.112s1.015,4.14-17.458,2.831l-10.178-.868Z",
    transform: "translate(-267.42 -435.09)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9741",
    "data-name": "Path 9741",
    d: "M288.93,435.09l6.126,16.112s1.015,4.14-17.458,2.831l-10.178-.868Z",
    transform: "translate(-239.284 -271.266)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9742",
    "data-name": "Path 9742",
    d: "M282.357,444.253s1.309,6.258,0,10.913c0,0-19.5,3.052-23.856,1.89s-7.008-3.339-7.141-4.412c0,0,.154-2.986,4.523-3.861s13.053-1.471,16.487-6.4S282.357,444.253,282.357,444.253Z",
    transform: "translate(-235.034 -272.723)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9743",
    "data-name": "Path 9743",
    d: "M314.056,321.451c6.229-8.884,34.865,1.809,34.865,1.809s2.728,21.385-8.678,27.092-27.849,5.4-32.291,10.023l-18.076,53.375s-6.493,2.714-15.936-1.559c0,0,11.479-40.307,14.848-54.617,3.331-14.164,24.9-23.775,24.9-23.775a13.1,13.1,0,0,1-2.478-4.471",
    transform: "translate(-241.009 -240.263)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744",
    "data-name": "Path 9744",
    d: "M366.875,350.52A31.62,31.62,0,0,1,364,352.785",
    transform: "translate(-264.84 -248.888)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9745",
    "data-name": "Path 9745",
    d: "M370.835,325.89c2.339,5.074,2.522,11.516-.735,16.215",
    transform: "translate(-266.454 -242.371)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9746",
    "data-name": "Path 9746",
    d: "M362.195,327s-.6,3.912,1.147,5.464,7.089,2.339,7.089,2.339",
    transform: "translate(-264.336 -242.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M329.23,327.24s.243,3.9-1.338,3.714-1.662,1.559-1.662,1.559",
    transform: "translate(-254.846 -242.728)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M306.542,263.918a13.311,13.311,0,0,1-.382-3s8.825-7.442,20.186-7.4c13.531.044,21.8,4.3,25.114,10.215,5.251,9.354,5.986,42.483,5.986,42.483s-33.953,5.236-38.821-1.184c-.846-1.118-.2-9.009-.2-9.009s-3.8-9.972-4.6-17.708a56.22,56.22,0,0,1-3.111-4.78,44.855,44.855,0,0,1-3.133-6.332",
    transform: "translate(-249.535 -223.221)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M306.542,263.918a13.311,13.311,0,0,1-.382-3s8.825-7.442,20.186-7.4c13.531.044,21.8,4.3,25.114,10.215,5.251,9.354,5.986,42.483,5.986,42.483s-33.953,5.236-38.821-1.184c-.846-1.118-.2-9.009-.2-9.009s-3.8-9.972-4.6-17.708a56.22,56.22,0,0,1-3.111-4.78,44.855,44.855,0,0,1-3.133-6.332",
    transform: "translate(-249.535 -223.221)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9750",
    "data-name": "Path 9750",
    d: "M324.36,278.49s5.185,20.113,4.412,24.54a8.09,8.09,0,0,0,.735,4.464,4.677,4.677,0,0,0-.735,5.427",
    transform: "translate(-254.351 -229.829)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M341.57,298.17a5.148,5.148,0,0,1-2.6-.824l-1.537-6.736a28.488,28.488,0,0,0,9.1-.64l1.647,7.354a24.641,24.641,0,0,1-2.817.61",
    transform: "translate(-257.809 -232.866)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9752",
    "data-name": "Path 9752",
    d: "M319.04,274.314s-4.412-18.8,6.721-20.981,13.421,3.015,12.766,6.538c-.875,4.7-10.1,16.223-10.1,16.223l-5.7-4.412Z",
    transform: "translate(-252.715 -223.035)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9753",
    "data-name": "Path 9753",
    d: "M319.04,274.314s-4.412-18.8,6.721-20.981,13.421,3.015,12.766,6.538c-.875,4.7-10.1,16.223-10.1,16.223l-5.7-4.412Z",
    transform: "translate(-252.715 -223.035)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9754",
    "data-name": "Path 9754",
    d: "M299.49,354.663s7.192-8.3,23.43-14.575c0,0-4.206-1.287-5.148-3.037",
    transform: "translate(-247.77 -245.324)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x1: 6.574,
    y2: 23.871,
    transform: "translate(36.689 134.746)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9755",
    "data-name": "Path 9755",
    d: "M357.07,301.6s2.942,4.964,15.053,4.508a18.76,18.76,0,0,0-8.266-5.148C358.909,299.641,357.07,301.6,357.07,301.6Z",
    transform: "translate(-263.006 -235.654)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9756",
    "data-name": "Path 9756",
    d: "M293.17,299.68s2.809-4.353,5.383-5.229,10.134-.949,11.3-.978,21.944,5.251,31.7,8.5L340.7,285.7l13.1,1.037s-.529,19.856-2.567,25.114-4.956,3.978-9.935,1.831c-19.583-8.435-31.056-14.311-32.122-13.972S293.17,299.68,293.17,299.68Z",
    transform: "translate(-246.098 -231.736)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9757",
    "data-name": "Path 9757",
    d: "M353.215,270.081a12.223,12.223,0,0,0-.324,4.133c.581,5.089,3.059,17.311,3.059,17.311s12.215,1.743,15.053,4.508c0,0,2.015-16.179-2.089-24.393s-8.347-9.119-8.347-9.119c-2.684-.662-5.148,1.838-6.508,5.052",
    transform: "translate(-261.887 -225.575)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112",
    transform: "translate(90.953 36.84)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9758",
    "data-name": "Path 9758",
    d: "M353.215,270.081a12.223,12.223,0,0,0-.324,4.133c.581,5.089,3.059,17.311,3.059,17.311s12.215,1.743,15.053,4.508c0,0,2.015-16.179-2.089-24.393s-8.347-9.119-8.347-9.119c-2.684-.662-5.148,1.838-6.508,5.052",
    transform: "translate(-352.839 -262.415)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9759",
    "data-name": "Path 9759",
    d: "M304.55,281.4a16.238,16.238,0,0,0,6.251,3.162",
    transform: "translate(-249.109 -230.599)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9760",
    "data-name": "Path 9760",
    d: "M357.07,281.4s4.412,8.339,9.987,10.178",
    transform: "translate(-263.006 -230.599)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9761",
    "data-name": "Path 9761",
    d: "M318.19,368.75s.816.618,1.147,2.846",
    transform: "translate(-252.718 -253.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9762",
    "data-name": "Path 9762",
    d: "M314.08,372.62a5.148,5.148,0,0,1,3.6,2.074",
    transform: "translate(-251.631 -254.736)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9763",
    "data-name": "Path 9763",
    d: "M281,361s2.353,1.191,1.846,4.567",
    transform: "translate(-242.877 -251.661)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9764",
    "data-name": "Path 9764",
    d: "M277.63,364.9s3.214,1.9,3.442,3.611",
    transform: "translate(-241.986 -252.693)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9765",
    "data-name": "Path 9765",
    d: "M328.28,336.92s7.155,1,8.759,0",
    transform: "translate(-255.388 -245.29)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9766",
    "data-name": "Path 9766",
    d: "M323.145,270.481a13.524,13.524,0,0,1-.735-5.464,16.06,16.06,0,0,1,.2-1.875l-1.243-1.971-1.6-2.537,1.846-7.354s11.766,2.265,12.649,5.545S323.145,270.481,323.145,270.481Z",
    transform: "translate(-253.136 -222.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113",
    transform: "translate(66.634 28.651)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M322.964,267.457a16.053,16.053,0,0,1,.2-1.875l-1.243-1.971a9.406,9.406,0,0,0,5.743-3.221A7.229,7.229,0,0,1,322.964,267.457Z",
    transform: "translate(-320.339 -253.691)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M323.145,270.481a13.524,13.524,0,0,1-.735-5.464,16.06,16.06,0,0,1,.2-1.875l-1.243-1.971-1.6-2.537,1.846-7.354s11.766,2.265,12.649,5.545S323.145,270.481,323.145,270.481Z",
    transform: "translate(-253.136 -222.629)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M324.94,243.806c3.677-9.56,1.235-25.834-16.414-22.716-10.354,1.838-11.6,14.355-8.148,19.914s-.213,5.736,4.986,9.854c2.111,1.669,3.809,4.5,6.324,4.684,2.993.206,6.824-2.625,9.685-5.685",
    transform: "translate(-247.548 -214.536)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9771",
    "data-name": "Path 9771",
    d: "M310.75,247.725s2.6-2.368,5.7-1.39",
    transform: "translate(-250.749 -221.257)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9772",
    "data-name": "Path 9772",
    d: "M302.905,247.49a4.589,4.589,0,0,0-3.375-2.28",
    transform: "translate(-247.781 -221.022)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9773",
    "data-name": "Path 9773",
    d: "M306.131,253s-.375,1.9-.868,3.831,3.089.875,2.942.581",
    transform: "translate(-249.285 -223.084)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9774",
    "data-name": "Path 9774",
    d: "M311.79,261.357a7.817,7.817,0,0,0,3.875-2.537",
    transform: "translate(-251.025 -224.624)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9775",
    "data-name": "Path 9775",
    d: "M315.1,251.315a.808.808,0,1,1-1.412.787.736.736,0,0,1-.1-.375.808.808,0,1,1,1.412-.787A.735.735,0,0,1,315.1,251.315Z",
    transform: "translate(-251.471 -222.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9776",
    "data-name": "Path 9776",
    d: "M304.633,251.078c.147.529.044,1.03-.235,1.1s-.625-.294-.735-.831-.037-1.03.243-1.1S304.471,250.541,304.633,251.078Z",
    transform: "translate(-248.861 -222.353)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9777",
    "data-name": "Path 9777",
    d: "M312.539,228.94s-2.736,7.155-9.5,6.994a10.643,10.643,0,0,0,2.993-3.493s-5.207,5.148-10.406,2.53-2.647-14.8,5.332-19.605,16.142-3.523,18.907,1.074c0,0,5.589-.515,8.053,7.7,2.206,7.354-1.324,18.5-4.773,18.627-5.346.2-6.42-5.6-6.42-5.6A15.3,15.3,0,0,1,312.539,228.94Z",
    transform: "translate(-246.03 -212.319)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9778",
    "data-name": "Path 9778",
    d: "M327.57,250.01s-.169-6.751,3.677-5.935,1.059,8.619-1.831,8.538",
    transform: "translate(-255.2 -220.704)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 61.692,
    height: 4.464,
    rx: 1.63,
    transform: "translate(0 67.208)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-143",
    transform: "translate(60.226 272.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9779",
    "data-name": "Path 9779",
    d: "M102.791,425.86H77.78L80.4,448.723h19.775Z",
    transform: "translate(-68.183 -377.059)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9780",
    "data-name": "Path 9780",
    d: "M111.727,404.22s-10.921.86-11.377,8.92C100.35,413.14,111.41,418.229,111.727,404.22Z",
    transform: "translate(-74.155 -371.333)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9781",
    "data-name": "Path 9781",
    d: "M80.7,405.059s-6.1-8.251-15.965-4.023C64.73,401.036,70.753,410.986,80.7,405.059Z",
    transform: "translate(-64.73 -370.172)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9782",
    "data-name": "Path 9782",
    d: "M65.846,371.519s-1.758,15.87,12.693,11.5C78.539,383.021,73.95,371.35,65.846,371.519Z",
    transform: "translate(-65.007 -362.68)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9783",
    "data-name": "Path 9783",
    d: "M87.8,359.5s-11.428,6.163-3.022,15.517C84.772,375.017,92.781,368.332,87.8,359.5Z",
    transform: "translate(-69.219 -359.5)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9784",
    "data-name": "Path 9784",
    d: "M104.638,378.775S92.21,377.518,92.21,389.019C92.21,389.019,104.638,389.512,104.638,378.775Z",
    transform: "translate(-72.001 -364.59)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9785",
    "data-name": "Path 9785",
    d: "M91.191,419.428s5.663-11.884.228-23.988-7.28-22.3-4.412-29.489",
    transform: "translate(-70.27 -361.207)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9786",
    "data-name": "Path 9786",
    d: "M99.972,383s-7.45,2.942-9.972,10.626",
    transform: "translate(-71.417 -365.718)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9787",
    "data-name": "Path 9787",
    d: "M71.21,380.15s4.3,5.883,11.59,5.229",
    transform: "translate(-66.445 -364.964)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9788",
    "data-name": "Path 9788",
    d: "M71.21,403.77s11.913,3.427,16.649,2.309",
    transform: "translate(-66.445 -371.214)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9789",
    "data-name": "Path 9789",
    d: "M107.155,409.15s-5.332,5.883-10.685,5.758",
    transform: "translate(-73.129 -372.638)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 27.158,
    height: 3.228,
    transform: "translate(8.523 48.293)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-143",
    transform: "translate(269.699 289.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9790",
    "data-name": "Path 9790",
    d: "M372.861,397a50.235,50.235,0,0,0-15.583,16.179c-6.479,10.81-11.612,26.018-3.64,27.945l7.582-.287,14.59-5.008-1.53-2.942s-12.774,6.766-14.958,6.766-5.03.544-6.229-.331,4.2-20.532,15.752-27.084S372.861,397,372.861,397Z",
    transform: "translate(-349.575 -386.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114",
    transform: "translate(0 10.721)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9791",
    "data-name": "Path 9791",
    d: "M372.861,397a50.235,50.235,0,0,0-15.583,16.179c-6.479,10.81-11.612,26.018-3.64,27.945l7.582-.287,14.59-5.008-1.53-2.942s-12.774,6.766-14.958,6.766-5.03.544-6.229-.331,4.2-20.532,15.752-27.084S372.861,397,372.861,397Z",
    transform: "translate(-349.575 -397)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M372.861,397a50.235,50.235,0,0,0-15.583,16.179c-6.479,10.81-11.612,26.018-3.64,27.945l7.582-.287,14.59-5.008-1.53-2.942s-12.774,6.766-14.958,6.766-5.03.544-6.229-.331,4.2-20.532,15.752-27.084S372.861,397,372.861,397Z",
    transform: "translate(-349.575 -386.279)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9794",
    "data-name": "Path 9794",
    d: "M392.53,386.053s0-3.169,4.8-3.6a4.942,4.942,0,0,1,5.486,4.192h-1.655s.037-2.772-3.493-2.986a2.888,2.888,0,0,0-3.4,2.986Z",
    transform: "translate(-360.941 -382.421)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9795",
    "data-name": "Path 9795",
    d: "M379.985,438.8c-10.156,0-8.229-45.543-7.06-47.8s30.636-3.383,33.541-2.427,14.553,46.33,8.126,49.955Z",
    transform: "translate(-355.5 -383.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(16.467 4.276)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M379.985,438.8c-10.156,0-8.229-45.543-7.06-47.8s30.636-3.383,33.541-2.427,14.553,46.33,8.126,49.955Z",
    transform: "translate(-371.966 -388.235)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9798",
    "data-name": "Path 9798",
    d: "M379.985,438.8c-10.156,0-8.229-45.543-7.06-47.8s30.636-3.383,33.541-2.427,14.553,46.33,8.126,49.955Z",
    transform: "translate(-355.5 -383.959)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9799",
    "data-name": "Path 9799",
    d: "M373.27,390.367c3.677.787,5.795,15.693,10.744,19.488s28.283,2.978,30.923,0-2.522-19.7-6.273-22.26-6.42-.074-16.973-1.243C376.05,384.609,373.27,390.367,373.27,390.367Z",
    transform: "translate(-355.845 -383.374)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9800",
    "data-name": "Path 9800",
    d: "M408.16,403.542l4.324,3.53a.588.588,0,0,1,.066.831h0l-3.368,3.633a.574.574,0,0,1-.809,0h0l-4.3-4.008a.581.581,0,0,1,0-.809h0l3.331-3.1A.574.574,0,0,1,408.16,403.542Z",
    transform: "translate(-363.952 -387.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116",
    transform: "translate(39.956 15.453)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9801",
    "data-name": "Path 9801",
    d: "M408.16,403.542l4.324,3.53a.588.588,0,0,1,.066.831h0l-3.368,3.633a.574.574,0,0,1-.809,0h0l-4.3-4.008a.581.581,0,0,1,0-.809h0l3.331-3.1A.574.574,0,0,1,408.16,403.542Z",
    transform: "translate(-403.907 -403.435)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9803",
    "data-name": "Path 9803",
    d: "M408.16,403.542l4.324,3.53a.588.588,0,0,1,.066.831h0l-3.368,3.633a.574.574,0,0,1-.809,0h0l-4.3-4.008a.581.581,0,0,1,0-.809h0l3.331-3.1A.574.574,0,0,1,408.16,403.542Z",
    transform: "translate(-363.952 -387.981)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9804",
    "data-name": "Path 9804",
    d: "M390.22,428.475s19.547,1.611,29.144-.875a8.244,8.244,0,0,1,2.743,3.934c.875,2.618,2.7,11.575-2.743,13.869s-25,1.853-27.614-.735S390.22,428.475,390.22,428.475Z",
    transform: "translate(-360.271 -394.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117",
    transform: "translate(29.727 33.224)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9805",
    "data-name": "Path 9805",
    d: "M390.22,428.475s19.547,1.611,29.144-.875a8.244,8.244,0,0,1,2.743,3.934c.875,2.618,2.7,11.575-2.743,13.869s-25,1.853-27.614-.735S390.22,428.475,390.22,428.475Z",
    transform: "translate(-389.998 -427.6)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9807",
    "data-name": "Path 9807",
    d: "M390.22,428.475s19.547,1.611,29.144-.875a8.244,8.244,0,0,1,2.743,3.934c.875,2.618,2.7,11.575-2.743,13.869s-25,1.853-27.614-.735S390.22,428.475,390.22,428.475Z",
    transform: "translate(-360.271 -394.376)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9808",
    "data-name": "Path 9808",
    d: "M390.3,428.475s2.294,6.185,3.493,7.133,26.592.949,29.416-1.346-1.044-6.442-3.758-6.663C419.444,427.6,401.654,429.674,390.3,428.475Z",
    transform: "translate(-360.351 -394.376)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9809",
    "data-name": "Path 9809",
    d: "M376.664,427s.655,12.994,1.964,15.943a6.8,6.8,0,0,1-6.295,0c-3.309-1.75-2.765-12.943-2.111-12.913S376.664,427,376.664,427Z",
    transform: "translate(-354.908 -394.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4118",
    "data-name": "Group 4118",
    transform: "translate(14.821 32.783)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9810",
    "data-name": "Path 9810",
    d: "M376.664,427s.655,12.994,1.964,15.943a6.8,6.8,0,0,1-6.295,0c-3.309-1.75-2.765-12.943-2.111-12.913S376.664,427,376.664,427Z",
    transform: "translate(-369.729 -427)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9812",
    "data-name": "Path 9812",
    d: "M376.664,427s.655,12.994,1.964,15.943a6.8,6.8,0,0,1-6.295,0c-3.309-1.75-2.765-12.943-2.111-12.913S376.664,427,376.664,427Z",
    transform: "translate(-354.908 -394.217)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9813",
    "data-name": "Path 9813",
    d: "M376.257,427l-4.92.985s-4.692,3.6-2.618,4.8S376.14,431.045,376.257,427Z",
    transform: "translate(-354.501 -394.217)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar2);
export default __webpack_public_path__ + "static/media/char2.2cb2634ecac7a308858bc3e22e0b379d.svg";
export { ForwardRef as ReactComponent };